import { css } from '@sail/ui';
export const styles = {
    icon: css({
        width: '21px',
        height: '15px',
        objectFit: 'none'
    })
};
export const flagCoordinates = {
    AD: css({
        objectPosition: '-10px -10px'
    }),
    AE: css({
        objectPosition: '-41px -10px'
    }),
    AG: css({
        objectPosition: '-72px -10px'
    }),
    AM: css({
        objectPosition: '-134px -10px'
    }),
    AR: css({
        objectPosition: '-196px -10px'
    }),
    AT: css({
        objectPosition: '-227px -10px'
    }),
    AU: css({
        objectPosition: '-258px -10px'
    }),
    BE: css({
        objectPosition: '-382px -10px'
    }),
    BF: css({
        objectPosition: '-413px -10px'
    }),
    BG: css({
        objectPosition: '-444px -10px'
    }),
    BO: css({
        objectPosition: '-41px -35px'
    }),
    BR: css({
        objectPosition: '-72px -35px'
    }),
    CA: css({
        objectPosition: '-196px -35px'
    }),
    CD: css({
        objectPosition: '-227px -35px'
    }),
    CG: css({
        objectPosition: '-258px -35px'
    }),
    CH: css({
        objectPosition: '-289px -35px'
    }),
    CL: css({
        objectPosition: '-351px -35px'
    }),
    CM: css({
        objectPosition: '-382px -35px'
    }),
    CN: css({
        objectPosition: '-413px -35px'
    }),
    CO: css({
        objectPosition: '-444px -35px'
    }),
    CR: css({
        objectPosition: '-475px -35px'
    }),
    CY: css({
        objectPosition: '-506px -35px'
    }),
    CZ: css({
        objectPosition: '-10px -60px'
    }),
    DE: css({
        objectPosition: '-41px -60px'
    }),
    DJ: css({
        objectPosition: '-72px -60px'
    }),
    DK: css({
        objectPosition: '-103px -60px'
    }),
    DO: css({
        objectPosition: '-134px -60px'
    }),
    DZ: css({
        objectPosition: '-165px -60px'
    }),
    EC: css({
        objectPosition: '-196px -60px'
    }),
    EE: css({
        objectPosition: '-227px -60px'
    }),
    EG: css({
        objectPosition: '-258px -60px'
    }),
    ES: css({
        objectPosition: '-289px -60px'
    }),
    EU: css({
        objectPosition: '-351px -60px'
    }),
    FI: css({
        objectPosition: '-382px -60px'
    }),
    FO: css({
        objectPosition: '-413px -60px'
    }),
    FR: css({
        objectPosition: '-444px -60px'
    }),
    GA: css({
        objectPosition: '-475px -60px'
    }),
    GB: css({
        objectPosition: '-506px -60px'
    }),
    GI: css({
        objectPosition: '-41px -85px'
    }),
    GL: css({
        objectPosition: '-72px -85px'
    }),
    GM: css({
        objectPosition: '-103px -85px'
    }),
    GR: css({
        objectPosition: '-134px -85px'
    }),
    GT: css({
        objectPosition: '-165px -85px'
    }),
    GU: css({
        objectPosition: '-196px -85px'
    }),
    HK: css({
        objectPosition: '-258px -85px'
    }),
    HN: css({
        objectPosition: '-289px -85px'
    }),
    HR: css({
        objectPosition: '-320px -85px'
    }),
    HT: css({
        objectPosition: '-351px -85px'
    }),
    HU: css({
        objectPosition: '-382px -85px'
    }),
    ID: css({
        objectPosition: '-413px -85px'
    }),
    IE: css({
        objectPosition: '-444px -85px'
    }),
    IL: css({
        objectPosition: '-475px -85px'
    }),
    IM: css({
        objectPosition: '-506px -85px'
    }),
    IN: css({
        objectPosition: '-10px -110px'
    }),
    IQ: css({
        objectPosition: '-41px -110px'
    }),
    IR: css({
        objectPosition: '-72px -110px'
    }),
    IS: css({
        objectPosition: '-103px -110px'
    }),
    IT: css({
        objectPosition: '-134px -110px'
    }),
    JE: css({
        objectPosition: '-165px -110px'
    }),
    JM: css({
        objectPosition: '-196px -110px'
    }),
    JO: css({
        objectPosition: '-227px -110px'
    }),
    JP: css({
        objectPosition: '-258px -110px'
    }),
    KE: css({
        objectPosition: '-289px -110px'
    }),
    KG: css({
        objectPosition: '-320px -110px'
    }),
    KN: css({
        objectPosition: '-382px -110px'
    }),
    KP: css({
        objectPosition: '-413px -110px'
    }),
    KR: css({
        objectPosition: '-444px -110px'
    }),
    KW: css({
        objectPosition: '-475px -110px'
    }),
    KZ: css({
        objectPosition: '-506px -110px'
    }),
    LA: css({
        objectPosition: '-10px -135px'
    }),
    LB: css({
        objectPosition: '-41px -135px'
    }),
    LC: css({
        objectPosition: '-72px -135px'
    }),
    LI: css({
        objectPosition: '-103px -135px'
    }),
    LS: css({
        objectPosition: '-165px -135px'
    }),
    LT: css({
        objectPosition: '-196px -135px'
    }),
    LU: css({
        objectPosition: '-227px -135px'
    }),
    LV: css({
        objectPosition: '-258px -135px'
    }),
    MA: css({
        objectPosition: '-289px -135px'
    }),
    MG: css({
        objectPosition: '-382px -135px'
    }),
    MK: css({
        objectPosition: '-413px -135px'
    }),
    ML: css({
        objectPosition: '-444px -135px'
    }),
    MM: css({
        objectPosition: '-475px -135px'
    }),
    MT: css({
        objectPosition: '-41px -160px'
    }),
    MX: css({
        objectPosition: '-103px -160px'
    }),
    MY: css({
        objectPosition: '-134px -160px'
    }),
    NA: css({
        objectPosition: '-196px -160px'
    }),
    NE: css({
        objectPosition: '-227px -160px'
    }),
    NG: css({
        objectPosition: '-258px -160px'
    }),
    NI: css({
        objectPosition: '-289px -160px'
    }),
    NL: css({
        objectPosition: '-320px -160px'
    }),
    NO: css({
        objectPosition: '-351px -160px'
    }),
    NZ: css({
        objectPosition: '-382px -160px'
    }),
    OM: css({
        objectPosition: '-413px -160px'
    }),
    PA: css({
        objectPosition: '-444px -160px'
    }),
    PE: css({
        objectPosition: '-475px -160px'
    }),
    PG: css({
        objectPosition: '-506px -160px'
    }),
    PH: css({
        objectPosition: '-10px -185px'
    }),
    PK: css({
        objectPosition: '-41px -185px'
    }),
    PL: css({
        objectPosition: '-72px -185px'
    }),
    PR: css({
        objectPosition: '-103px -185px'
    }),
    PS: css({
        objectPosition: '-134px -185px'
    }),
    PT: css({
        objectPosition: '-165px -185px'
    }),
    PY: css({
        objectPosition: '-196px -185px'
    }),
    QA: css({
        objectPosition: '-227px -185px'
    }),
    RO: css({
        objectPosition: '-289px -185px'
    }),
    RS: css({
        objectPosition: '-320px -185px'
    }),
    RU: css({
        objectPosition: '-351px -185px'
    }),
    RW: css({
        objectPosition: '-382px -185px'
    }),
    SA: css({
        objectPosition: '-413px -185px'
    }),
    SE: css({
        objectPosition: '-444px -185px'
    }),
    SG: css({
        objectPosition: '-475px -185px'
    }),
    SI: css({
        objectPosition: '-506px -185px'
    }),
    SK: css({
        objectPosition: '-10px -210px'
    }),
    SL: css({
        objectPosition: '-41px -210px'
    }),
    SN: css({
        objectPosition: '-103px -210px'
    }),
    SO: css({
        objectPosition: '-134px -210px'
    }),
    SV: css({
        objectPosition: '-165px -210px'
    }),
    TD: css({
        objectPosition: '-196px -210px'
    }),
    TH: css({
        objectPosition: '-227px -210px'
    }),
    TJ: css({
        objectPosition: '-258px -210px'
    }),
    TL: css({
        objectPosition: '-289px -210px'
    }),
    TR: css({
        objectPosition: '-351px -210px'
    }),
    TT: css({
        objectPosition: '-382px -210px'
    }),
    TW: css({
        objectPosition: '-413px -210px'
    }),
    TZ: css({
        objectPosition: '-444px -210px'
    }),
    UA: css({
        objectPosition: '-475px -210px'
    }),
    UG: css({
        objectPosition: '-506px -210px'
    }),
    US: css({
        objectPosition: '-10px -235px'
    }),
    UY: css({
        objectPosition: '-41px -235px'
    }),
    VE: css({
        objectPosition: '-103px -235px'
    }),
    VN: css({
        objectPosition: '-134px -235px'
    }),
    XX: css({
        objectPosition: '-165px -235px'
    }),
    YE: css({
        objectPosition: '-196px -235px'
    }),
    ZA: css({
        objectPosition: '-227px -235px'
    })
};

//# sourceMappingURL=FlagIconStyles.js.map